// src/modules/app-views/companies/config.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************

import CompaniesInit from './pages/Init';
import ListProvider from 'components/core/ListProvider';
import { API } from 'constants/Api';
import { decodeBase64 } from 'utils/crypto';
import companiesInitActionButton from 'modules/app-views/companies/pages/Init/actions/actionButton';
import DocumentProvider from 'components/core/DocumentProvider';
import subscriptionActionButton from 'modules/app-views/account/pages/Subscription/actions/actionButton';
// import useZustand from 'hooks/useZustand'; // REMOVED: Not needed, column functions receive data as props
import CardHeaderTitle from 'layouts/Pages/PageHeader/CardHeaderTitle';
import CardHeaderSubtitle from 'layouts/Pages/PageHeader/CardHeaderSubtitle';
import CardHeaderCountryIcon from 'layouts/Pages/PageHeader/CardHeaderCountryIcon';
import CompaniesDocument from 'modules/app-views/companies/pages/Document';
import companiesDocumentActionButton from 'modules/app-views/companies/pages/Document/actions/actionButton';
import companiesDocumentDropdownMenu from 'modules/app-views/companies/pages/Document/actions/dropdownMenu';
import companiesDocumentDecorateRequest from './pages/Document/decorators/request';
import companiesDocumentDecodeResponse from './pages/Document/decorators/response';
import CardHeaderColumn from 'layouts/Pages/PageHeader/CardHeaderColumn';
import {
  documentCodeItem,
  createdAtItem,
  updatedAtItem,
  emailItem,
  phoneItem,
  locationItem,
  cpfCnpjItem,
  genderSegmentItem,
  ageFoundedItem,
} from 'layouts/Pages/PageHeader/CardHeaderColumn/items';
import CardHeaderIcons from 'layouts/Pages/PageHeader/CardHeaderIcons';

// NAO REMOVE MEUS COMENTÁRIOS!!!
// const urlBase64 =
//   'eyJwYWdpbmF0aW9uIjp7InBhZ2UiOjEsInNpemUiOjEwfSwic29ydCI6W3siZmllbGQiOiJjbnBqLnZhbHVlIiwib3JkZXIiOiJkZXNjIiwiaW5kZXgiOjF9LHsiZmllbGQiOiJuYW1lIiwib3JkZXIiOiJhc2MiLCJpbmRleCI6Mn1dLCJzZWFyY2giOnsiY25wai52YWx1ZSI6IjEyMyIsIm5hbWUiOiJsdWEifSwidGV4dFNlYXJjaCI6IiIsImZpbHRlciI6e30sImRyYXdlciI6eyJmb2xkZXIiOiJpbmJveCJ9fQ%253D%253D';
// const b64 = decodeBase64(urlBase64);
// console.log('decodeBase45 obj: ', b64);
// console.log('decodeBase45 str: ', JSON.stringify(b64));
// NAO REMOVE MEUS COMENTÁRIOS!!!

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const MODULE_ID = 'companies';

// *******************************************************************************
// PRE CONFIG
// *******************************************************************************
const preConfigChanges = appId => {
  CONFIG.appId = appId;
};

// *******************************************************************************
// MODULE CONFIGURATION
// *******************************************************************************
const CONFIG = {
  version: 2,
  id: MODULE_ID,
  initialPage: 'init',
  initialParams: null,
  initialQuery: null,
};

// *******************************************************************************
// MODULE PAGES
// *******************************************************************************
const PAGES = {
  init: {
    // ───────────────────────────────────────────────────────────────────────
    // PAGE CORE
    // ───────────────────────────────────────────────────────────────────────
    layout: 'list', // 'page' | 'list' | 'document'
    moduleId: MODULE_ID,
    component: props => (
      <ListProvider {...props}>
        <CompaniesInit />
      </ListProvider>
    ),

    // ───────────────────────────────────────────────────────────────────────
    // TOUR
    // ───────────────────────────────────────────────────────────────────────
    tour: {
      firstModal: null,
      lastModal: null,
      onFinish: null,
      triggerConfettiOnFinish: false,
      videoLink: {
        br: null,
        us: null,
      },
    },

    // ───────────────────────────────────────────────────────────────────────
    // API & DATA
    // ───────────────────────────────────────────────────────────────────────
    api: {
      url: API.ENTITIES.PAGINATION,
      params: null,
      query: null,

      // data transformation
      returnAsObject: false,

      // initial configuration
      autoFetch: true,
      fetchWithoutSubscription: false,
      removeSubscriptionIdFromHeader: false,
      persistInStore: true,
    },

    // ───────────────────────────────────────────────────────────────────────
    // DECORATORS
    // ───────────────────────────────────────────────────────────────────────
    decorators: {
      request: null,
      response: null,
    },

    // ───────────────────────────────────────────────────────────────────────
    // ROUTING & NAVIGATION
    // ───────────────────────────────────────────────────────────────────────
    routing: {
      endpoint: null,
      paramKey: null,
      query: null,
    },

    // ───────────────────────────────────────────────────────────────────────
    // LIST PROVIDER ONLY - PAGINATION CONFIGURATION
    // ───────────────────────────────────────────────────────────────────────
    // Sort structure: array of { field, order, index }
    // - field: string - Field path (e.g., 'name', 'cnpj.value', '_metadata.audit.createdAt')
    // - order: 'asc' | 'desc' - Sort direction
    // - index: number - Sort priority (1 = highest, sorted first)
    // ───────────────────────────────────────────────────────────────────────
    pagination: {
      pagination: { page: 1, size: 10 },
      sort: [
        { field: 'name', order: 'asc', index: 1 },

        // Add more fields for multi-column sorting:
        // { field: 'cnpj.value', order: 'desc', index: 2 },
      ],
      search: {},
      textSearch: '',
      filter: {
        entityProfile: ['company'],
      },
      drawer: { folder: 'inbox' },
    },

    // ───────────────────────────────────────────────────────────────────────
    // LIST PROVIDER ONLY - TABLE SETTINGS
    // ───────────────────────────────────────────────────────────────────────
    table: {
      actions: [
        'edit',

        // 'view',

        'archive',
        'remove',
      ],
      hiddenColumns: [
        'line',
        'cnpj',
        'name',
        'fullName',
        'nameWithAvatar',
        'contacts',
        'createdAt',
      ],
    },

    // ───────────────────────────────────────────────────────────────────────
    // DOCUMENT PROVIDER ONLY - PAGE SETTINGS
    // ───────────────────────────────────────────────────────────────────────
    settings: null,
    // settings: {
    // initialTab: null,
    // initialValues: {},
    // viewMode: 'auto',
    // actions: ['editRefresh', companiesDocumentActionButton(), companiesDocumentDropdownMenu(), 'return'],
    // },

    // ───────────────────────────────────────────────────────────────────────
    // HEADER CONFIGURATION
    // ───────────────────────────────────────────────────────────────────────
    header: {
      visible: true,
      style: 'default', // 'default' | 'card'
      actions: ['filter', 'refresh', companiesInitActionButton()],

      // avatar: {
      //   visible: false,
      //   placeholder: 'photo',
      // },

      navigation: {
        showTitle: true,
        showBreadcrumb: true,
      },

      // buttons: {
      //   filter: true,
      //   refresh: true,
      //   goBack: false,
      //   parameters: false,
      // },
      //
      // stats: {
      //   showTotalRecords: true,
      // },

      // Only for style: 'card'
      // card: {
      //   title: null,
      //   subtitle: null,
      //   column1: null,
      //   column2: null,
      //   column3: null,
      //   tags: null,
      //   icons: null,
      //   footer: null,
      // },
    },

    // ───────────────────────────────────────────────────────────────────────
    // TABS CONFIGURATION
    // ───────────────────────────────────────────────────────────────────────
    // tabs: {},

    // ───────────────────────────────────────────────────────────────────────
    // CUSTOM COMPONENTS
    // ───────────────────────────────────────────────────────────────────────
    // components: {},

    // ───────────────────────────────────────────────────────────────────────
    // LIST SETTINGS (only for layout: 'list')
    // ───────────────────────────────────────────────────────────────────────
    // list: {
    //   table: {
    //     showLineNumbers: true,
    //   },
    //
    //   header: {
    //     showFolder: true,
    //     showRecordCount: true,
    //   },
    //
    //   actions: {
    //     columns: ['edit', 'view', 'archive', 'remove'],
    //   },
    //
    //   preview: {
    //     title: 'edit_item',
    //     showCard: false,
    //     header: null,
    //     body: null,
    //     actions: null,
    //   },
    //
    //   filter: {
    //     component: null,
    //   },
    //
    //   behavior: {
    //     editGoToPage: 'document',
    //   },
    // },
  },

  document: {
    highSecurity: false, // Verify userId in URL params matches storedUser._id

    // ───────────────────────────────────────────────────────────────────────
    // PAGE CORE
    // ───────────────────────────────────────────────────────────────────────
    layout: 'document',
    moduleId: MODULE_ID,
    component: props => (
      <DocumentProvider {...props}>
        <CompaniesDocument />
      </DocumentProvider>
    ),

    // ───────────────────────────────────────────────────────────────────────
    // TOUR
    // ───────────────────────────────────────────────────────────────────────
    tour: {
      firstModal: null,
      lastModal: null,
      onFinish: null,
      triggerConfettiOnFinish: false,
      videoLink: {
        br: null,
        us: null,
      },
    },

    // ───────────────────────────────────────────────────────────────────────
    // API & DATA
    // ───────────────────────────────────────────────────────────────────────
    api: {
      url: API.ENTITIES.URL,
      params: null,
      query: {
        filter: JSON.stringify({ entityProfile: ['company'] }),
      },

      // data transformation
      returnAsObject: true,

      // initial configuration
      autoFetch: true,
      fetchWithoutSubscription: false,
      removeSubscriptionIdFromHeader: false,
      persistInStore: true,
    },

    // ───────────────────────────────────────────────────────────────────────
    // DECORATORS
    // ───────────────────────────────────────────────────────────────────────
    decorators: {
      request: companiesDocumentDecorateRequest,
      response: companiesDocumentDecodeResponse,
    },

    // ───────────────────────────────────────────────────────────────────────
    // ROUTING & NAVIGATION
    // ───────────────────────────────────────────────────────────────────────
    routing: {
      endpoint: '/:_id',
      paramKey: '_id',
      query: null,
    },

    // ───────────────────────────────────────────────────────────────────────
    // LIST PROVIDER ONLY - PAGINATION CONFIGURATION
    // ───────────────────────────────────────────────────────────────────────
    pagination: null,

    // ───────────────────────────────────────────────────────────────────────
    // LIST PROVIDER ONLY - TABLE SETTINGS
    // ───────────────────────────────────────────────────────────────────────
    table: null,

    // ───────────────────────────────────────────────────────────────────────
    // DOCUMENT PROVIDER ONLY - PAGE SETTINGS
    // ───────────────────────────────────────────────────────────────────────
    settings: {
      initialTab: 'record',
      initialValues: {},
      actions: [
        'editRefresh',
        companiesDocumentActionButton(),
        companiesDocumentDropdownMenu(),
        'return',
      ],
      viewMode: 'auto',
    },

    // ───────────────────────────────────────────────────────────────────────
    // HEADER CONFIGURATION
    // ───────────────────────────────────────────────────────────────────────
    header: {
      visible: true,
      style: 'card', // 'default' | 'card'
      //
      avatar: {
        visible: true,
        placeholder: 'logo',
      },
      //
      navigation: {
        showTitle: true,
        showBreadcrumb: true,
        // showBreadcrumb: ({ data, moduleCtx }) => {
        //   if (moduleCtx?.mode === 'add') {
        //     return { add: ['subscriptions', 'new_subscription'], remove: 'add' };
        //   } else {
        //     return { add: ['subscriptions', data?.name], remove: [data?._id, 'new_subscription'] };
        //   }
        // },
      },
      //
      // buttons: {
      //   filter: false,
      //   refresh: true,
      // goBack: true,
      //   parameters: false,
      // },
      //
      // stats: {
      //   showTotalRecords: false,
      // },

      card: {
        title: props => <CardHeaderTitle {...props} />,
        subtitle: props => <CardHeaderSubtitle {...props} />,

        column1: props => (
          <CardHeaderColumn {...props} items={[documentCodeItem, createdAtItem, updatedAtItem]} />
        ),
        column2: props => (
          <CardHeaderColumn {...props} items={[emailItem, phoneItem, locationItem]} />
        ),
        column3: props => (
          <CardHeaderColumn {...props} items={[cpfCnpjItem, genderSegmentItem, ageFoundedItem]} />
        ),
        icons: (data, countryCode) => <CardHeaderIcons data={data} countryCode={countryCode} />,
      },
    },

    // ───────────────────────────────────────────────────────────────────────
    // CUSTOM COMPONENTS
    // ───────────────────────────────────────────────────────────────────────
    // components: {},
  },
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default { CONFIG, PAGES, preConfigChanges };
